import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { ProductCard } from "./ProductCard";

/**
 * "You Might Also Like" cross-sell rail. Server picks 6-8 complementary
 * products from admin-configured category-mapping rules (see backend
 * DEFAULT_CROSSSELL_RULES). Section auto-hides when nothing is returned.
 */
export function RelatedProducts({ slug, limit = 8 }) {
  const [items, setItems] = useState(null);

  useEffect(() => {
    if (!slug) return;
    let alive = true;
    api
      .get(`/products/${slug}/related`, { params: { limit } })
      .then((r) => alive && setItems(Array.isArray(r.data) ? r.data : []))
      .catch(() => alive && setItems([]));
    return () => {
      alive = false;
    };
  }, [slug, limit]);

  if (!items || items.length === 0) return null;

  return (
    <section
      className="mt-16 border-t-2 border-black pt-12"
      data-testid="related-products-section"
      aria-labelledby="related-products-heading"
    >
      <div className="mb-8 flex items-end justify-between gap-4">
        <div>
          <p className="text-[10px] font-bold uppercase tracking-[0.35em] text-zinc-500">
            Complete The Set
          </p>
          <h2
            id="related-products-heading"
            className="mt-2 font-display text-3xl font-black tracking-tighter text-black sm:text-4xl"
          >
            You Might Also Like
          </h2>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
        {items.map((p, i) => (
          <ProductCard
            key={p.slug}
            product={p}
            index={i}
            data-testid={`related-product-${p.slug}`}
          />
        ))}
      </div>
    </section>
  );
}
